import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setSectionFrequency } from "../../repository/slice";

function* getSectionFrequencyWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/badge/admin/list", payload);
        if (isError) {

        } else {
            yield put(setSectionFrequency(data));
        }
    } catch (error) {
        console.error("getSectionFrequencyWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSectionFrequencyWatcher() {
    yield takeLatest("@saga/GET_SECTION_FREQUENCY", getSectionFrequencyWorker);
};